// className 合并 helper：clsx 处理条件类、tailwind-merge 处理冲突 utility 去重。
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
